import { render } from "./Registration-popup.vue?vue&type=template&id=340a967c&scoped=true"
import script from "./Registration-popup.vue?vue&type=script&lang=js"
export * from "./Registration-popup.vue?vue&type=script&lang=js"

import "./Registration-popup.vue?vue&type=style&index=0&id=340a967c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340a967c"]])

export default __exports__